import { PageController } from '@client/components/_core/layout/PageController';
import { errorMessage } from '@client/components/_ui/feedback/error-message/ErrorMessage';
import { message } from '@client/components/_ui/feedback/message';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { match } from 'ts-pattern';
import { type TaskList, TaskListForm } from './TaskListForm';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/claims/task-lists/search/add')({
    staticData: {
        metadata: {
            title: 'Add task list',
        },
        ui: {
            title: 'Add task list',
        },
        presentation: 'overlay',
        modules: ['claim'],
    },
    component: AddTaskList,
});

function AddTaskList() {
    const { trpc, trpcUtils } = useTrpc();
    const [open, setOpen] = useState(true);
    const orgId = useOrgId();
    const navigate = useNavigate();
    const { mutate: createTaskList, isPending: isCreating } = trpc.taskList.createTaskList.useMutation();

    const handleSubmit = (values: TaskList) => {
        message.loading('Creating task list...');
        createTaskList(
            {
                name: values.name ?? '',
            },
            {
                onSuccess: () => {
                    message.success('Task list created');
                    trpcUtils.taskList.listTaskLists.invalidate();
                    setOpen(false);
                },
                onError(error) {
                    errorMessage.show(error);
                },
            },
        );
    };
    return (
        <PageController route={Route}>
            <TaskListForm
                open={open}
                mode="add"
                data={{ name: '' }}
                state={match({ isCreating })
                    .with({ isCreating: true }, () => 'submitting' as const)
                    .otherwise(() => 'ready' as const)}
                onSubmit={handleSubmit}
                onCloseFinished={() => {
                    navigate({
                        to: '/console/$orgId/configuration/claims-products/claims/task-lists/search',
                        params: { orgId },
                    });
                }}
            />
        </PageController>
    );
}
